// @ts-check

/**
 * Base Error class for Custom error types
 * @class
 * @extends Error
 */
class ExtendableError extends Error {
  /**
   * @param {string} message
   * @constructor
   */
  constructor(message = '') {
    super(message)

    // Extending Error does not propagate `message`
    Object.defineProperty(this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    })

    // Assign name property from the extending class name
    Object.defineProperty(this, 'name', {
      configurable: true,
      enumerable: false,
      value: this.constructor.name,
      writable: true
    })

    // Assign the stacktrace
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor)
    } else {
      Object.defineProperty(this, 'stack', {
        configurable: true,
        enumerable: false,
        value: (new Error(message)).stack,
        writable: true
      })
    }
  }
}

module.exports = {
  ExtendableError
}
